app.controller("ExamsManagerSettingsController", [
    "$scope", "ExamsManagerService", "$stateParams", "StaticData", "$state", "$uibModal", "ConfirmModal", "toastr",
    function ($scope, ExamsManagerService, $stateParams, StaticData, $state, $uibModal, ConfirmModal, toastr) {
        $scope.scheduleUrl = null;
        $scope.examsStatus = null;
        $scope.examsShowScheduleStatusBachelor = null;
        $scope.examsShowScheduleStatusMaster = null;
        $scope.examsShowScheduleStatusTeacher = null;
        $scope.examsMoveStatusBachelor = null;
        $scope.examsMoveStatusMaster = null;
        $scope.examsMoveStatusTeacher = null;


        StaticData.getItemsByKey("exam-schedule").then(function (data) {
            $scope.scheduleUrl = data[0].value;
        });

        $scope.fetchStatus = function (key) {
            ExamsManagerService.fetchExamsSystemStatus({key: key}).then(function (data) {
                $scope[key] = data.value;
            });
        };

        $scope.fetchStatus('examsStatus');
        $scope.fetchStatus('examsShowScheduleStatusBachelor');
        $scope.fetchStatus('examsShowScheduleStatusMaster');
        $scope.fetchStatus('examsShowScheduleStatusTeacher');
        $scope.fetchStatus('examsMoveStatusBachelor');
        $scope.fetchStatus('examsMoveStatusMaster');
        $scope.fetchStatus('examsMoveStatusTeacher');

        $scope.updateStatus = function (key) {
            var status = "enabled";
            if ($scope[key] === "enabled") {
                status = "disabled";
            }
            ExamsManagerService.updateExamsSystemStatus({key: key, value: status}).then(function () {
                $scope.fetchStatus(key);
            });
        };

        function generateScheduleModal(barrierEnabled, level) {
            $uibModal.open({
                controller: "ExamsManagerGenerateSchedule",
                templateUrl: _pb + 'admin/exams/manager/exams-manager-generate-schedule.html',
                size: "md",
                resolve: {
                    params: function () {
                        return {
                            barrierEnabled: barrierEnabled,
                            level: level,
                        };
                    }
                }
            }).result
                .then(function (result) {
                }, function () {
                });
        }

        $scope.generateMidExams = function (level) {
            ConfirmModal.show({
                title: "შუალედურის ცხრილის გენერირება",
                message: "გსურთ ძველი ცხრილის განადგურება და ახლის შექმნა? ყურადღება, ეს ძაააალიან მნიშვნელოვანია!"
            }).result.then(function () {
                generateScheduleModal(false, level);
            });
        };

        $scope.generateFinalExams = function (level) {
            ConfirmModal.show({
                title: "ფინალურის ცხრილის გენერირება",
                message: "გსურთ ძველი ცხრილის განადგურება და ახლის შექმნა? ყურადღება, ეს ძაააალიან მნიშვნელოვანია!"
            }).result.then(function () {
                generateScheduleModal(true, level);
            });
        };


        $scope.clear = function (level) {
            ConfirmModal.show({
                title: "ცხრილის გასუფთავება",
                message: "გსურთ ძველი ცხრილის წაშლა? ყურადღება, ცხრილი დაიკარგება!"
            }).result.then(function () {
                ExamsManagerService.clearExams(level).then(function () {
                    toastr.success('ცხრილი გასუფთავებულია');
                });
            });
        };

        $scope.addScheduleURL = function (subject, group, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddMessageContainer",
                templateUrl: _pb + 'lecturer/add-message-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            subjectName: 'ბმულის გაწერა',
                            scheduleUrl: $scope.scheduleUrl
                        };
                    }
                }
            }).result
                .then(function () {
                    toastr.success('', 'ბმული განახლებულია');
                    setTimeout(function () {
                        $window.location.reload();
                    }, 500);
                }, function () {
                });
        };
    }
]);
